export default __webpack_public_path__ + "static/community-1-9aff640e7a0c1fb404bf7e823bfbd218.png";